import { Box, Divider, Stack } from "@mui/material"

export function AuthoringSideBySideRow({
    left,
    right,
    after = null,
    below = null,
    dataCy = "authoring-side-by-side-row",
    className,
}) {
    return (
        <>
            <Stack
                className={className ? `two-schedules ${className}` : "two-schedules"}
                spacing={0}
                direction="row"
                sx={{ overflow: "hidden", width: 1 }}
                data-cy={dataCy}
            >
                <Box width={1 / 2} pl={4} className="left" data-cy="authoring-side-by-side-left">
                    {left}
                </Box>
                <Box width={116} className="center" data-cy="authoring-side-by-side-center" />
                <Box width={1 / 2} pr={4} className="right" data-cy="authoring-side-by-side-right">
                    {right}
                </Box>
            </Stack>
            {after}
            {below}
            <Divider my={1} />
        </>
    )
}
